import { render } from "./alternative-medication-page.vue?vue&type=template&id=11885a34&scoped=true&ts=true"
import script from "./alternative-medication-page.vue?vue&type=script&lang=ts"
export * from "./alternative-medication-page.vue?vue&type=script&lang=ts"

import "./alternative-medication-page.vue?vue&type=style&index=0&id=11885a34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11885a34"]])

export default __exports__